import { ArrowRight, Check, Eye } from "lucide-react";
import { CAPITAL_DECKS, CREDIBILITY_DECKS, DELIVERY_DECKS, MASTER_DECKS, PARTNER_DECKS, VISION_DECKS } from "./deckRegistry";

const Card = ({ deck, active, onSelect }) => {
  const selectable = deck.mode === "password";
  const Tag = selectable ? "button" : "div";
  return (
    <Tag
      type={selectable ? "button" : undefined}
      onClick={selectable ? () => onSelect(deck.id) : undefined}
      className={`pdadm-card ${active ? "on" : ""} ${selectable ? "" : "static"}`}
      data-testid={`pdadm-deck-${deck.id}`}
      aria-pressed={selectable ? active : undefined}
    >
      <span className="pdadm-card-media">
        <img src={deck.image} alt="" style={{ objectPosition: deck.imagePos }} loading="lazy" />
        <span className="shade" />
        <span className="nr">{deck.nr}</span>
        {active && <span className="chk" data-testid={`pdadm-deck-${deck.id}-valgt`}><Check size={12} strokeWidth={3} /></span>}
      </span>
      <span className="pdadm-card-body">
        <span className="t">{deck.name}</span>
        <span className="a">{deck.alias}</span>
        <span className="w">{deck.what}</span>
        <span className="who"><b>For:</b> {deck.who}</span>
        <span className="pdadm-card-foot">
          <span className="m">{deck.slides} slides · {deck.mode === "password" ? "Passord + PDF" : "Åpne lenker"}</span>
          {selectable ? (
            <a href={deck.previewPath} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} className="lnk" data-testid={`pdadm-preview-${deck.id}`}>
              <Eye size={12} /> Forhåndsvis
            </a>
          ) : deck.mode === "open" ? (
            <>
              <a href={deck.publicPath} target="_blank" rel="noreferrer" className="lnk" data-testid={`pdadm-open-${deck.id}`}>
                <Eye size={12} /> Åpen lenke
              </a>
              <a href={deck.adminPath} target="_blank" rel="noreferrer" className="lnk" data-testid={`pdadm-admin-${deck.id}`}>
                Dialogvariant <ArrowRight size={12} />
              </a>
            </>
          ) : (
            <a href={deck.adminPath} className="lnk" data-testid={`pdadm-admin-${deck.id}`}>
              Administrer <ArrowRight size={12} />
            </a>
          )}
        </span>
      </span>
    </Tag>
  );
};

export const DeckCards = ({ valgt, onSelect }) => (
  <div data-testid="pdadm-cards">
    <p className="pdadm-group" data-testid="pdadm-group-vision">Vision deck <span>hva Norwegian AI Summit er — talere, investorer, Bergen, teamet</span></p>
    <div className="pdadm-cards">
      {VISION_DECKS.map((d) => <Card key={d.id} deck={d} active={valgt === d.id} onSelect={onSelect} />)}
    </div>
    <p className="pdadm-group mt-6" data-testid="pdadm-group-master">Master partner deck <span>det kommersielle hoveddecket — Presenting Partner på toppen, hele arkitekturen under</span></p>
    <div className="pdadm-cards">
      {MASTER_DECKS.map((d) => <Card key={d.id} deck={d} active={valgt === d.id} onSelect={onSelect} />)}
    </div>
    <p className="pdadm-group mt-6" data-testid="pdadm-group-credibility">Hvem står bak <span>norsk énsider til sponsorer og partnere — åpen lenke uten passord (/deck/team), dialogversjon med statuser for admin</span></p>
    <div className="pdadm-cards">
      {CREDIBILITY_DECKS.map((d) => <Card key={d.id} deck={d} active={valgt === d.id} onSelect={onSelect} />)}
    </div>
    <p className="pdadm-group mt-6" data-testid="pdadm-group-capital">Investordeck <span>norsk — Bergen-basert kapital som garantist for Kevin-eksponeringen · byen som vertskap</span></p>
    <div className="pdadm-cards">
      {CAPITAL_DECKS.map((d) => <Card key={d.id} deck={d} active={valgt === d.id} onSelect={onSelect} />)}
    </div>
    <p className="pdadm-group mt-6" data-testid="pdadm-group-partner">Partner decks <span>ett deck per kategori — én partner per kategori</span></p>
    <div className="pdadm-cards">
      {PARTNER_DECKS.map((d) => <Card key={d.id} deck={d} active={valgt === d.id} onSelect={onSelect} />)}
      <div className="pdadm-card pdadm-card-ny" data-testid="pdadm-deck-ny">
        <span className="t">Neste kategori</span>
        <span className="w">Én ny oppføring i deck-registeret — samme passord, samme lenkebygger, samme PDF-pipeline.</span>
      </div>
    </div>
    <p className="pdadm-group mt-6" data-testid="pdadm-group-delivery">Delivery partners <span>leveranseapparatet — «delivered with», ikke «sponsored by»</span></p>
    <div className="pdadm-cards">
      {DELIVERY_DECKS.map((d) => <Card key={d.id} deck={d} active={valgt === d.id} onSelect={onSelect} />)}
    </div>
  </div>
);
